// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .Contact-root-TMIUP {
 	padding-left: 20px;
 	padding-right: 20px;
 	position: relative;
 	width: 100%;
 	z-index: 1;
 	height: auto;
 	background-color: var(--common-gray-bg-color);
 }

 .Contact-container-HYCP7 {
 	margin: 0 auto;
 	padding: 0 0 40px;
 	max-width: var(--max-content-width);
 }

 @media screen and (max-width: 767px) {
 	.Contact-root-TMIUP {
 		padding-left: 0px;
 		padding-right: 0px;
 		position: relative;
 		width: 100%;
 		z-index: 1;
 		height: auto;
 		background-color: var(--common-gray-bg-color);
 	}
 }`, "",{"version":3,"sources":["webpack://./src/routes/contact/Contact.css"],"names":[],"mappings":"CAAC;EACC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,6CAA6C;CAC9C;;CAEA;EACC,cAAc;EACd,iBAAiB;EACjB,mCAAmC;CACpC;;CAEA;EACC;GACC,iBAAiB;GACjB,kBAAkB;GAClB,kBAAkB;GAClB,WAAW;GACX,UAAU;GACV,YAAY;GACZ,6CAA6C;EAC9C;CACD","sourcesContent":[" .root {\n \tpadding-left: 20px;\n \tpadding-right: 20px;\n \tposition: relative;\n \twidth: 100%;\n \tz-index: 1;\n \theight: auto;\n \tbackground-color: var(--common-gray-bg-color);\n }\n\n .container {\n \tmargin: 0 auto;\n \tpadding: 0 0 40px;\n \tmax-width: var(--max-content-width);\n }\n\n @media screen and (max-width: 767px) {\n \t.root {\n \t\tpadding-left: 0px;\n \t\tpadding-right: 0px;\n \t\tposition: relative;\n \t\twidth: 100%;\n \t\tz-index: 1;\n \t\theight: auto;\n \t\tbackground-color: var(--common-gray-bg-color);\n \t}\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Contact-root-TMIUP`,
	"container": `Contact-container-HYCP7`
};
module.exports = ___CSS_LOADER_EXPORT___;
